__webpack_require__.p = "/Portfiolio_ReactJS/";